import React from 'react';
export function CancellationPolicy() {
  return <div className="w-full bg-white py-16" data-id="element-227">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-228">
        <h1 className="text-4xl font-bold text-slate-800 mb-8" data-id="element-229">
          Cancellation Policy
        </h1>
        <div className="prose prose-slate max-w-none" data-id="element-230">
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-231">
            Service Cancellation Terms
          </h2>
          <p className="text-slate-600 mb-4" data-id="element-232">
            We understand that circumstances change. You may cancel your repair
            service booking according to the following terms:
          </p>
          <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3" data-id="element-233">
            Refund Timeframes
          </h3>
          <ul className="list-disc pl-6 text-slate-600 space-y-3 mb-6" data-id="element-234">
            <li data-id="element-235">
              <strong data-id="element-236">0-14 days:</strong> Full refund available if no repair
              work has been completed
            </li>
            <li data-id="element-237">
              <strong data-id="element-238">15-28 days:</strong> Partial refund may be offered at our
              discretion
            </li>
            <li data-id="element-239">
              <strong data-id="element-240">After 28 days:</strong> No refund available
            </li>
          </ul>
          <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3" data-id="element-241">
            How to Cancel
          </h3>
          <p className="text-slate-600 mb-4" data-id="element-242">
            To cancel your service booking, please contact us with your order
            details:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-243">
            <li data-id="element-244">
              <strong data-id="element-245">Email:</strong> Sumittandon092@gmail.com
            </li>
            <li data-id="element-246">
              <strong data-id="element-247">Phone:</strong> 0800 055 4969
            </li>
          </ul>
          <p className="text-slate-600 mb-6" data-id="element-248">
            Approved refunds will be processed to your original payment method
            within 14 working days.
          </p>
          <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3" data-id="element-249">
            Exclusions
          </h3>
          <p className="text-slate-600 mb-4" data-id="element-250">
            Refunds are not available in the following circumstances:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-251">
            <li data-id="element-252">Pre-existing faults not disclosed at booking</li>
            <li data-id="element-253">Appliance misuse or lack of proper maintenance</li>
            <li data-id="element-254">Unauthorised repair work by third parties</li>
            <li data-id="element-255">Non-standard modifications to the appliance</li>
            <li data-id="element-256">Diagnostic fees once the engineer has attended and assessed</li>
          </ul>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-257">
            Appointment Changes
          </h2>
          <p className="text-slate-600 mb-4" data-id="element-258">
            If you need to reschedule your appointment rather than cancel,
            please contact us as soon as possible. We will do our best to
            accommodate alternative dates and times.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-259">
            Contact Us
          </h2>
          <p className="text-slate-600 mb-2" data-id="element-260">
            For cancellation requests or questions:
          </p>
          <p className="text-slate-600" data-id="element-261">
            Email: Sumittandon092@gmail.com
            <br data-id="element-262" />
            Phone: 0800 055 4969
            <br data-id="element-263" />
            Address: 5 London Rd, Portsmouth PO2 0BQ
          </p>
        </div>
      </div>
    </div>;
}